import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import ButtonCustom from '../atoms/button/ButtonCustom'
import InputCustom from '../atoms/input/InputCustom'
import styles from './onboarding.module.scss'
import { toastHelper } from '../../util/toastHelper'
import { useDispatch } from 'react-redux'
import { updateProfile } from '../../features/authSlice'

export default function Services({ userDetails, setUserDetails, setStep }) {
  const [newService, setNewService] = useState('')
  const dispatch = useDispatch()
  const services = userDetails.services || []

  const handleAdd = () => {
    const trimmed = newService.trim()
    if (!trimmed) return
    if (services.includes(trimmed)) {
      setNewService('')
      return
    }
    setUserDetails({
      ...userDetails,
      services: [...services, trimmed],
    })
    setNewService('')
  }

  const handleDelete = (s) => {
    setUserDetails({
      ...userDetails,
      services: services.filter((x) => x !== s),
    })
  }

  const handleNext = () => {
		if (services.length === 0) {
			toastHelper('Please add at least one service', 'error')
			return
		}
		if (userDetails.role === 'kazoo-planner') {
			dispatch(updateProfile(userDetails))
		} else {
			setStep((s) => s + 1)
		}
  }

  return (
    <div className={styles.form}>
      <h1>Services</h1>
      <p>
        Add the main services you offer. You can change these later.
      </p>

      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <InputCustom
          value={newService}
          onChange={(e) => setNewService(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault()
              handleAdd()
            }
          }}
          placeholder="Add Service"
        />
        <ButtonCustom variant="outlined" size="lg" onClick={handleAdd}>
          Add
        </ButtonCustom>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, maxHeight: 200, overflowY: 'auto' }}>
        {services.map((service) => (
          <ButtonCustom
            key={service}
            variant="pilled"
            size="md"
            onClick={() => handleDelete(service)}
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}
          >
            {service}
            <img
              src="/images/modal-close-icon.svg"
              alt="remove"
              style={{ width: 14, height: 14 }}
            />
          </ButtonCustom>
        ))}
      </Box>

      <div className={styles.skipBtn} style={{ marginTop: '2rem' }}>
        <button
          className="backButton"
          onClick={() => setStep((s) => s - 1)}
        >
          Back
        </button>
        <ButtonCustom onClick={handleNext}>
          {userDetails.role === 'kazoo-planner' ? 'Submit' : 'Next'}
        </ButtonCustom>
      </div>
    </div>
  )
}